import React, { FC } from 'react';
import PGUseCard from '../../components/PGUseCard';
import styles from './PGUse.module.scss';

interface Props {
  PGUmbrellaData: { [key: string]: string };
  PGSafeData: { [key: string]: string };
  PGEvnData: { [key: string]: string };
}
const PGUse: FC<Props> = (props) => {
  const { PGUmbrellaData, PGSafeData, PGEvnData } = props;
  const colImgClass = 'h-10.625r w-11.25r lg:h-21.25r lg:w-22.5r';
  const coldirClass = 'flex-row';
  return (
    <section className={styles['pg-use-box']}>
      <div className={styles['use-card-wrap']}>
        <PGUseCard pgUseCardData={PGUmbrellaData} compressOptions={{ quality: 30 }} />
      </div>
      <div className={styles['use-box-wrap']}>
        {/* 180*170 11.25r*10.625r */}
        {/* 360*340 22.5r*21.25r */}
        <div>
          <PGUseCard pgUseCardData={PGSafeData} cardDirClass={coldirClass} cardImgClass={colImgClass} />
        </div>
        <div>
          <PGUseCard pgUseCardData={PGEvnData} cardDirClass={coldirClass} cardImgClass={colImgClass} />
        </div>
      </div>
    </section>
  );
};
PGUse.defaultProps = {};

PGUse.displayName = 'PGUse';
export default PGUse;
